import React, { useEffect } from 'react'
import { sanitizeStrings, trackGAEvent } from '@moonpig/web-core-analytics'
import { ModuleLayoutContainer } from '../../modules/LayoutContainer/ModuleLayoutContainer'
import { mapModule } from '../../modules/map-modules'
import { getConciergeModules } from './utils/getConciergeModules'
import { PageTypeEnum, ProductContext } from '../../types'
import { createViewItemsWithAddonsGAEvent } from '../../analytics'
import { useProductStore } from '../../contexts/product'
import { StyledContainer } from './styled'

const CONCIERGE_PRODUCT_DETAILS_LOCATION = 'product details | ai concierge'

const productContext: ProductContext = {
  pageType: PageTypeEnum.HOME,
  location: '',
  onTrackingInfo: ({ product }) => ({
    label: sanitizeStrings(
      `${CONCIERGE_PRODUCT_DETAILS_LOCATION} | ${product.id}`,
    ),
    listName: sanitizeStrings(`${CONCIERGE_PRODUCT_DETAILS_LOCATION} | 1/1`),
    itemIndex: 0,
  }),
}

export const ConciergeProductModalComponent = () => {
  const [{ product }] = useProductStore()

  useEffect(() => {
    if (!product?.id) {
      return
    }

    trackGAEvent(
      createViewItemsWithAddonsGAEvent({
        product: {
          id: product.id,
          category:
            sanitizeStrings(product.category.department) ||
            product.category.name,
          title: product.title,
          variantTitle: product.masterVariant.title,
          price: product.masterVariant.price.centAmount,
          index: 0,
          categoryDepartment: product.category.department,
          inStock: product.masterVariant.inStock,
          isSponsored: product.isSponsored,
          internallyPromoted: product.internallyPromoted,
          dynamicImages: product.dynamicImages ?? null,
        },
        variants: product.variants,
        pageLocation: CONCIERGE_PRODUCT_DETAILS_LOCATION,
      }),
    )
  }, [product])

  return (
    <StyledContainer>
      <ModuleLayoutContainer
        onConfigureModules={getConciergeModules}
        onMapModule={mapModule}
        context={productContext}
      />
    </StyledContainer>
  )
}
